function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M111.64,58.32h-5c0,13.36-5.4,25.41-14.15,34.17-8.76,8.75-20.81,14.15-34.17,14.15-13.36,0-25.41-5.4-34.17-14.15-8.75-8.76-14.15-20.81-14.15-34.17,0-13.36,5.4-25.41,14.15-34.17,8.76-8.75,20.81-14.15,34.17-14.15,13.36,0,25.41,5.4,34.17,14.15,8.75,8.76,14.15,20.81,14.15,34.17h10c0-16.09-6.54-30.7-17.08-41.24C89.02,6.54,74.41,0,58.32,0,42.23,0,27.62,6.54,17.08,17.08,6.54,27.62,0,42.23,0,58.32c0,16.09,6.54,30.7,17.08,41.24,10.54,10.55,25.15,17.08,41.24,17.08,16.09,0,30.7-6.54,41.24-17.08,10.55-10.54,17.08-25.15,17.08-41.24h-5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M78.35,81.86v-2c-3.75,0-7.12-1.51-9.58-3.97-2.45-2.46-3.97-5.83-3.97-9.57v-16.22c0-3.75,1.51-7.12,3.97-9.58,2.46-2.45,5.83-3.96,9.58-3.97,3.75,0,7.12,1.51,9.57,3.97,2.45,2.46,3.97,5.83,3.97,9.58v16.22c0,3.75-1.51,7.12-3.97,9.57-2.46,2.45-5.83,3.96-9.57,3.97v4c9.69,0,17.54-7.85,17.54-17.54v-16.22c0-9.69-7.85-17.54-17.54-17.54-9.69,0-17.54,7.85-17.54,17.54v16.22c0,9.69,7.85,17.54,17.54,17.54v-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M38.35,81.86v-2c-3.75,0-7.12-1.51-9.58-3.97-2.45-2.46-3.97-5.83-3.97-9.57v-16.22c0-3.75,1.51-7.12,3.97-9.58,2.46-2.45,5.83-3.96,9.58-3.97,3.75,0,7.12,1.51,9.57,3.97,2.45,2.46,3.97,5.83,3.97,9.58v16.22c0,3.75-1.51,7.12-3.97,9.57-2.46,2.45-5.83,3.96-9.57,3.97v4c9.69,0,17.54-7.85,17.54-17.54v-16.22c0-9.69-7.85-17.54-17.54-17.54-9.69,0-17.54,7.85-17.54,17.54v16.22c0,9.69,7.85,17.54,17.54,17.54v-2Z"
})));

var SvgSpeedboardPlain = function SvgSpeedboardPlain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116.64 116.64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeedboardPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speedboard-plain.a0cb8ff3.svg";
export { ForwardRef as ReactComponent };